// Taken from https://github.com/vimeo/py-money/blob/master/money/currency.py
export const Currency = {
	AED: 'AED',
	AFN: 'AFN',
	ALL: 'ALL',
	AMD: 'AMD',
	ANG: 'ANG',
	AOA: 'AOA',
	ARS: 'ARS',
	AUD: 'AUD',
	AWG: 'AWG',
	AZN: 'AZN',
	BAM: 'BAM',
	BBD: 'BBD',
	BDT: 'BDT',
	BGN: 'BGN',
	BHD: 'BHD',
	BIF: 'BIF',
	BMD: 'BMD',
	BND: 'BND',
	BOB: 'BOB',
	// BOV: 'BOV',
	BRL: 'BRL',
	BSD: 'BSD',
	BTN: 'BTN',
	BWP: 'BWP',
	BYR: 'BYR',
	BYN: 'BYN',
	BZD: 'BZD',
	CAD: 'CAD',
	CDF: 'CDF',
	CHE: 'CHE',
	CHF: 'CHF',
	CHW: 'CHW',
	CLF: 'CLF',
	CLP: 'CLP',
	CNY: 'CNY',
	COP: 'COP',
	COU: 'COU',
	CRC: 'CRC',
	CUC: 'CUC',
	CUP: 'CUP',
	CVE: 'CVE',
	CZK: 'CZK',
	DJF: 'DJF',
	DKK: 'DKK',
	DOP: 'DOP',
	DZD: 'DZD',
	EGP: 'EGP',
	ERN: 'ERN',
	ETB: 'ETB',
	EUR: 'EUR',
	FJD: 'FJD',
	FKP: 'FKP',
	GBP: 'GBP',
	GEL: 'GEL',
	GHS: 'GHS',
	GIP: 'GIP',
	GMD: 'GMD',
	GNF: 'GNF',
	GTQ: 'GTQ',
	GYD: 'GYD',
	HKD: 'HKD',
	HNL: 'HNL',
	HRK: 'HRK',
	HTG: 'HTG',
	HUF: 'HUF',
	IDR: 'IDR',
	ILS: 'ILS',
	INR: 'INR',
	IQD: 'IQD',
	IRR: 'IRR',
	ISK: 'ISK',
	JMD: 'JMD',
	JOD: 'JOD',
	JPY: 'JPY',
	KES: 'KES',
	KGS: 'KGS',
	KHR: 'KHR',
	KMF: 'KMF',
	KPW: 'KPW',
	KRW: 'KRW',
	KWD: 'KWD',
	KYD: 'KYD',
	KZT: 'KZT',
	LAK: 'LAK',
	LBP: 'LBP',
	LKR: 'LKR',
	LRD: 'LRD',
	LSL: 'LSL',
	// LTL: 'LTL',
	// LVL: 'LVL',
	LYD: 'LYD',
	MAD: 'MAD',
	MDL: 'MDL',
	MGA: 'MGA',
	MKD: 'MKD',
	MMK: 'MMK',
	MNT: 'MNT',
	MOP: 'MOP',
	MRO: 'MRO',
	MUR: 'MUR',
	MVR: 'MVR',
	MWK: 'MWK',
	MXN: 'MXN',
	MXV: 'MXV',
	MYR: 'MYR',
	MZN: 'MZN',
	NAD: 'NAD',
	NGN: 'NGN',
	NIO: 'NIO',
	NOK: 'NOK',
	NPR: 'NPR',
	NZD: 'NZD',
	OMR: 'OMR',
	PAB: 'PAB',
	PEN: 'PEN',
	PGK: 'PGK',
	PHP: 'PHP',
	PKR: 'PKR',
	PLN: 'PLN',
	PYG: 'PYG',
	QAR: 'QAR',
	RON: 'RON',
	RSD: 'RSD',
	RUB: 'RUB',
	RWF: 'RWF',
	SAR: 'SAR',
	SBD: 'SBD',
	SCR: 'SCR',
	SDG: 'SDG',
	SEK: 'SEK',
	SGD: 'SGD',
	SHP: 'SHP',
	SLL: 'SLL',
	SOS: 'SOS',
	SRD: 'SRD',
	SSP: 'SSP',
	STD: 'STD',
	SVC: 'SVC',
	SYP: 'SYP',
	SZL: 'SZL',
	THB: 'THB',
	TJS: 'TJS',
	TMT: 'TMT',
	TND: 'TND',
	TOP: 'TOP',
	TRY: 'TRY',
	TTD: 'TTD',
	TWD: 'TWD',
	TZS: 'TZS',
	UAH: 'UAH',
	UGX: 'UGX',
	USD: 'USD',
	USN: 'USN',
	USS: 'USS',
	UYI: 'UYI',
	UYU: 'UYU',
	UZS: 'UZS',
	VEF: 'VEF',
	VND: 'VND',
	VUV: 'VUV',
	WST: 'WST',
	XAF: 'XAF',
	XAG: 'XAG',
	XAU: 'XAU',
	XBA: 'XBA',
	XBB: 'XBB',
	XBC: 'XBC',
	XBD: 'XBD',
	XCD: 'XCD',
	XDR: 'XDR',
	XFU: 'XFU',
	XOF: 'XOF',
	XPD: 'XPD',
	XPF: 'XPF',
	XPT: 'XPT',
	XSU: 'XSU',
	XTS: 'XTS',
	XUA: 'XUA',
	YER: 'YER',
	ZAR: 'ZAR',
	ZMW: 'ZMW',
	ZWL: 'ZWL',
}

export const allCurrencyCodes = Object.values(Currency)

export const CurrencyData = {
	[Currency.AED]: {
		displayName: 'UAE Dirham',
		numericCode: 784,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.AFN]: {
		displayName: 'Afghan Afghani',
		numericCode: 971,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.ALL]: {
		displayName: 'Albania Lek',
		numericCode: 8,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.AMD]: {
		displayName: 'Armenian Dram',
		numericCode: 51,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.ANG]: {
		displayName: 'Netherlands Antillean Guilder',
		numericCode: 532,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.AOA]: {
		displayName: 'Angolan Kwanza',
		numericCode: 973,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.ARS]: {
		displayName: 'Argentine Peso',
		numericCode: 32,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'before',
	},
	[Currency.AUD]: {
		displayName: 'Australian Dollar',
		numericCode: 36,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'before',
	},
	[Currency.AWG]: {
		displayName: 'Aruban Florin',
		numericCode: 533,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.AZN]: {
		displayName: 'Azerbaijanian Manat',
		numericCode: 944,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.BAM]: {
		displayName: 'Bosnia-Herzegovina Convertible Mark',
		numericCode: 977,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.BBD]: {
		displayName: 'Barbados Dollar',
		numericCode: 52,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.BDT]: {
		displayName: 'Bangladeshi Taka',
		numericCode: 50,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.BGN]: {
		displayName: 'Bulgarian Lev',
		numericCode: 975,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.BHD]: {
		displayName: 'Bahraini Dinar',
		numericCode: 48,
		defaultFractionDigits: 3,
		subUnit: 1000,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.BIF]: {
		displayName: 'Burundi Franc',
		numericCode: 108,
		defaultFractionDigits: 0,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.BMD]: {
		displayName: 'Bermudian Dollar',
		numericCode: 60,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.BND]: {
		displayName: 'Brunei Dollar',
		numericCode: 96,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.BOB]: {
		displayName: 'Bolivian Boliviano',
		numericCode: 68,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	// No longer in circulation (https://financial-dictionary.thefreedictionary.com/BOV)
	// [Currency.BOV]: {
	//   displayName: 'Bolivian Mvdol',
	//   numericCode: 984,
	//   defaultFractionDigits: 2,
	//   subUnit: 100,
	//   spaced: true,
	//   symbolPosition: 'after',
	// },
	[Currency.BRL]: {
		displayName: 'Brazilian Real',
		numericCode: 986,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'before',
	},
	[Currency.BSD]: {
		displayName: 'Bahamian Dollar',
		numericCode: 44,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.BTN]: {
		displayName: 'Bhutanese Ngultrum',
		numericCode: 64,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.BWP]: {
		displayName: 'Botswanan Pula',
		numericCode: 72,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.BYN]: {
		displayName: 'Belarusian Ruble',
		numericCode: 933,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.BZD]: {
		displayName: 'Belize Dollar',
		numericCode: 84,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.CAD]: {
		displayName: 'Canadian Dollar',
		numericCode: 124,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'before',
	},
	[Currency.CDF]: {
		displayName: 'Congolese Franc',
		numericCode: 976,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.CHF]: {
		displayName: 'Swiss Franc',
		numericCode: 756,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'before',
	},
	[Currency.CLP]: {
		displayName: 'Chilean Peso',
		numericCode: 152,
		defaultFractionDigits: 0,
		subUnit: 1, // 100 - It is officially subdivided into 100 centavos, although there are no current centavo-denominated coins
		spaced: true,
		symbolPosition: 'before',
	},
	[Currency.CNY]: {
		displayName: 'Chinese Yuan',
		numericCode: 156,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'before',
	},
	[Currency.COP]: {
		displayName: 'Colombian Peso',
		numericCode: 170,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'before',
	},
	[Currency.CRC]: {
		displayName: 'Costa Rican Colon',
		numericCode: 188,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.CUC]: {
		displayName: 'Peso Convertible',
		numericCode: 931,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.CUP]: {
		displayName: 'Cuban Peso',
		numericCode: 192,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.CVE]: {
		displayName: 'Cape Verde Escudo',
		numericCode: 132,
		defaultFractionDigits: 0,
		subUnit: 1, // 100 - subunit discontinued
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.CZK]: {
		displayName: 'Czech Koruna',
		numericCode: 203,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.DJF]: {
		displayName: 'Djibouti Franc',
		numericCode: 262,
		defaultFractionDigits: 0,
		subUnit: 1, // 100 - historically, it was subdivided into 100 centimes
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.DKK]: {
		displayName: 'Danish Krone',
		numericCode: 208,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'before',
	},
	[Currency.DOP]: {
		displayName: 'Dominican Peso',
		numericCode: 214,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.DZD]: {
		displayName: 'Algerian Dinar',
		numericCode: 12,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.EGP]: {
		displayName: 'Egyptian Pound',
		numericCode: 818,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.ERN]: {
		displayName: 'Eritrean Nakfa',
		numericCode: 232,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.ETB]: {
		displayName: 'Ethiopian Birr',
		numericCode: 230,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.EUR]: {
		displayName: 'Euro',
		numericCode: 978,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'before',
	},
	[Currency.FJD]: {
		displayName: 'Fiji Dollar',
		numericCode: 242,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.FKP]: {
		displayName: 'Falkland Islands Pound',
		numericCode: 238,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.GBP]: {
		displayName: 'Pound Sterling',
		numericCode: 826,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: false,
		symbolPosition: 'before',
	},
	[Currency.GEL]: {
		displayName: 'Georgian Lari',
		numericCode: 981,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.GHS]: {
		displayName: 'Ghana Cedi',
		numericCode: 936,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.GIP]: {
		displayName: 'Gibraltar Pound',
		numericCode: 292,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.GMD]: {
		displayName: 'Gambian Dalasi',
		numericCode: 270,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.GNF]: {
		displayName: 'Guinea Franc',
		numericCode: 324,
		defaultFractionDigits: 0,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.GTQ]: {
		displayName: 'Guatemalan Quetzal',
		numericCode: 320,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.GYD]: {
		displayName: 'Guyana Dollar',
		numericCode: 328,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.HKD]: {
		displayName: 'Hong Kong Dollar',
		numericCode: 344,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'before',
	},
	[Currency.HNL]: {
		displayName: 'Honduran Lempira',
		numericCode: 340,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.HRK]: {
		displayName: 'Croatian Kuna',
		numericCode: 191,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.HTG]: {
		displayName: 'Haitian Gourde',
		numericCode: 332,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.HUF]: {
		displayName: 'Hungarian Forint',
		numericCode: 348,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.IDR]: {
		displayName: 'Indonesian Rupiah',
		numericCode: 360,
		defaultFractionDigits: 0,
		subUnit: 1, // 100 - The subunit sen is no longer in practical use
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.ILS]: {
		displayName: 'New Israeli Sheqel',
		numericCode: 376,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'before',
	},
	[Currency.INR]: {
		displayName: 'Indian Rupee',
		numericCode: 356,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'before',
	},
	[Currency.IQD]: {
		displayName: 'Iraqi Dinar',
		numericCode: 368,
		defaultFractionDigits: 3,
		subUnit: 1000,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.IRR]: {
		displayName: 'Iranian Rial',
		numericCode: 364,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.ISK]: {
		displayName: 'Iceland Krona',
		numericCode: 352,
		defaultFractionDigits: 0,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.JMD]: {
		displayName: 'Jamaican Dollar',
		numericCode: 388,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.JOD]: {
		displayName: 'Jordanian Dinar',
		numericCode: 400,
		defaultFractionDigits: 3,
		subUnit: 1000,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.JPY]: {
		displayName: 'Japanese Yen',
		numericCode: 392,
		defaultFractionDigits: 0,
		subUnit: 1,
		spaced: true,
		symbolPosition: 'before',
	},
	[Currency.KES]: {
		displayName: 'Kenyan Shilling',
		numericCode: 404,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.KGS]: {
		displayName: 'Kyrgystani Som',
		numericCode: 417,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.KHR]: {
		displayName: 'Cambodian Riel',
		numericCode: 116,
		defaultFractionDigits: 0,
		subUnit: 1, // 100 - subunit no longer used
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.KMF]: {
		displayName: 'Comoro Franc',
		numericCode: 174,
		defaultFractionDigits: 0,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.KPW]: {
		displayName: 'North Korean Won',
		numericCode: 408,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.KRW]: {
		displayName: 'South Korean Won',
		numericCode: 410,
		defaultFractionDigits: 0,
		subUnit: 1,
		spaced: true,
		symbolPosition: 'before',
	},
	[Currency.KWD]: {
		displayName: 'Kuwaiti Dinar',
		numericCode: 414,
		defaultFractionDigits: 3,
		subUnit: 1000,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.KYD]: {
		displayName: 'Cayman Islands Dollar',
		numericCode: 136,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.KZT]: {
		displayName: 'Kazakhstani Tenge',
		numericCode: 398,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.LAK]: {
		displayName: 'Laotian Kip',
		numericCode: 418,
		defaultFractionDigits: 2,
		spaced: false,
		symbolPosition: 'after',
		subUnit: 100,
	},
	[Currency.LBP]: {
		displayName: 'Lebanese Pound',
		numericCode: 422,
		defaultFractionDigits: 2,
		spaced: false,
		symbolPosition: 'after',
		subUnit: 100,
	},
	[Currency.LKR]: {
		displayName: 'Sri Lanka Rupee',
		numericCode: 144,
		defaultFractionDigits: 2,
		spaced: false,
		symbolPosition: 'after',
		subUnit: 100,
	},
	[Currency.LRD]: {
		displayName: 'Liberian Dollar',
		numericCode: 430,
		defaultFractionDigits: 2,
		spaced: false,
		symbolPosition: 'after',
		subUnit: 100,
	},
	[Currency.LSL]: {
		displayName: 'Lesotho Loti',
		numericCode: 426,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	// Replaced by the EUR in 2015 (https://en.wikipedia.org/wiki/Lithuania_and_the_euro)
	// [Currency.LTL]: {
	//   displayName: 'Lithuanian Litas',
	//   numericCode: 440,
	//   defaultFractionDigits: 2,
	//   subUnit: 100,
	//   spaced: true,
	//   symbolPosition: 'after',
	// },
	// Replaced by the EUR in 2014 (https://en.wikipedia.org/wiki/Latvian_euro_coins)
	// [Currency.LVL]: {
	//   displayName: 'Latvian Lats',
	//   numericCode: 428,
	//   defaultFractionDigits: 2,
	//   subUnit: 100,
	//   spaced: true,
	//   symbolPosition: 'after',
	// },
	[Currency.LYD]: {
		displayName: 'Libyan Dinar',
		numericCode: 434,
		defaultFractionDigits: 3,
		subUnit: 1000,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.MAD]: {
		displayName: 'Moroccan Dirham',
		numericCode: 504,
		defaultFractionDigits: 2,
		subUnit: 100,

		spaced: false,
		symbolPosition: 'after',
	},
	[Currency.MDL]: {
		displayName: 'Moldovan Leu',
		numericCode: 498,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.MGA]: {
		displayName: 'Malagasy Ariary',
		numericCode: 969,
		defaultFractionDigits: 2,
		subUnit: 5,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.MKD]: {
		displayName: 'Macedonian Denar',
		numericCode: 807,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.MMK]: {
		displayName: 'Myanmar Kyat',
		numericCode: 104,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.MNT]: {
		displayName: 'Mongolian Tugrik',
		numericCode: 496,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.MOP]: {
		displayName: 'Macanese Pataca',
		numericCode: 446,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.MRO]: {
		displayName: 'Mauritanian Ouguiya',
		numericCode: 478,
		defaultFractionDigits: 2,
		subUnit: 5,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.MUR]: {
		displayName: 'Mauritius Rupee',
		numericCode: 480,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.MVR]: {
		displayName: 'Maldivian Rufiyaa',
		numericCode: 462,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.MWK]: {
		displayName: 'Malawian Kwacha',
		numericCode: 454,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.MXN]: {
		displayName: 'Mexican Peso',
		numericCode: 484,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'before',
	},
	[Currency.MYR]: {
		displayName: 'Malaysian Ringgit',
		numericCode: 458,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'before',
	},
	[Currency.MZN]: {
		displayName: 'Mozambique Metical',
		numericCode: 943,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.NAD]: {
		displayName: 'Namibia Dollar',
		numericCode: 516,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.NGN]: {
		displayName: 'Nigerian Naira',
		numericCode: 566,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.NIO]: {
		displayName: 'Cordoba Oro',
		numericCode: 558,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.NOK]: {
		displayName: 'Norwegian Krone',
		numericCode: 578,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'before',
	},
	[Currency.NPR]: {
		displayName: 'Nepalese Rupee',
		numericCode: 524,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.NZD]: {
		displayName: 'New Zealand Dollar',
		numericCode: 554,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'before',
	},
	[Currency.OMR]: {
		displayName: 'Rial Omani',
		numericCode: 512,
		defaultFractionDigits: 3,
		subUnit: 1000,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.PAB]: {
		displayName: 'Panamanian Balboa',
		numericCode: 590,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.PEN]: {
		displayName: 'Peruvian Nuevo Sol',
		numericCode: 604,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.PGK]: {
		displayName: 'Papua New Guinean Kina',
		numericCode: 598,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.PHP]: {
		displayName: 'Philippine Peso',
		numericCode: 608,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'before',
	},
	[Currency.PKR]: {
		displayName: 'Pakistan Rupee',
		numericCode: 586,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.PLN]: {
		displayName: 'Polish Zloty',
		numericCode: 985,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.PYG]: {
		displayName: 'Paraguayan Guarani',
		numericCode: 600,
		defaultFractionDigits: 0,
		subUnit: 1,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.QAR]: {
		displayName: 'Qatari Rial',
		numericCode: 634,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.RON]: {
		displayName: 'New Romanian Leu',
		numericCode: 946,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.RSD]: {
		displayName: 'Serbian Dinar',
		numericCode: 941,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.RUB]: {
		displayName: 'Russian Ruble',
		numericCode: 643,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: false,
		symbolPosition: 'after',
	},
	[Currency.RWF]: {
		displayName: 'Rwanda Franc',
		numericCode: 646,
		defaultFractionDigits: 0,
		subUnit: 1,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.SAR]: {
		displayName: 'Saudi Riyal',
		numericCode: 682,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.SBD]: {
		displayName: 'Solomon Islands Dollar',
		numericCode: 90,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.SCR]: {
		displayName: 'Seychelles Rupee',
		numericCode: 690,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.SDG]: {
		displayName: 'Sudanese Pound',
		numericCode: 938,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.SEK]: {
		displayName: 'Swedish Krona',
		numericCode: 752,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.SGD]: {
		displayName: 'Singapore Dollar',
		numericCode: 702,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: false,
		symbolPosition: 'before',
	},
	[Currency.SHP]: {
		displayName: 'Saint Helena Pound',
		numericCode: 654,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.SLL]: {
		displayName: 'Sierra Leonean Leone',
		numericCode: 694,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.SOS]: {
		displayName: 'Somali Shilling',
		numericCode: 706,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.SRD]: {
		displayName: 'Surinam Dollar',
		numericCode: 968,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.SSP]: {
		displayName: 'South Sudanese Pound',
		numericCode: 728,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.STD]: {
		displayName: 'São Tomé and Príncipe Dobra',
		numericCode: 678,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.SVC]: {
		displayName: 'El Salvador Colon',
		numericCode: 222,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.SYP]: {
		displayName: 'Syrian Pound',
		numericCode: 760,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.SZL]: {
		displayName: 'Swazi Lilangeni',
		numericCode: 748,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.THB]: {
		displayName: 'Thai Baht',
		numericCode: 764,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.TJS]: {
		displayName: 'Tajikistani Somoni',
		numericCode: 972,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.TMT]: {
		displayName: 'Turkmenistan New Manat',
		numericCode: 934,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.TND]: {
		displayName: 'Tunisian Dinar',
		numericCode: 788,
		defaultFractionDigits: 3,
		subUnit: 1000,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.TOP]: {
		displayName: 'Tongan Pa’anga',
		numericCode: 776,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.TRY]: {
		displayName: 'Turkish Lira',
		numericCode: 949,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.TTD]: {
		displayName: 'Trinidad and Tobago Dollar',
		numericCode: 780,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.TWD]: {
		displayName: 'New Taiwan Dollar',
		numericCode: 901,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'before',
	},
	[Currency.TZS]: {
		displayName: 'Tanzanian Shilling',
		numericCode: 834,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.UAH]: {
		displayName: 'Ukrainian Hryvnia',
		numericCode: 980,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.UGX]: {
		displayName: 'Uganda Shilling',
		numericCode: 800,
		defaultFractionDigits: 0,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.USD]: {
		displayName: 'US Dollar',
		numericCode: 840,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: false,
		symbolPosition: 'before',
	},
	[Currency.UYU]: {
		displayName: 'Peso Uruguayo',
		numericCode: 858,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.UZS]: {
		displayName: 'Uzbekistan Sum',
		numericCode: 860,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.VEF]: {
		displayName: 'Venezuelan Bolivar',
		numericCode: 937,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.VND]: {
		displayName: 'Vietnamese Dong',
		numericCode: 704,
		defaultFractionDigits: 0,
		subUnit: 1, // 10 - subunits are obsolete due to inflation and have been unused in Vietnam for several decades (https://en.wikipedia.org/wiki/Vietnamese_%C4%91%E1%BB%93ng)
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.VUV]: {
		displayName: 'Vanuatu Vatu',
		numericCode: 548,
		defaultFractionDigits: 0,
		subUnit: 1,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.WST]: {
		displayName: 'Samoan Tala',
		numericCode: 882,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.XCD]: {
		displayName: 'East Caribbean Dollar',
		numericCode: 951,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.YER]: {
		displayName: 'Yemeni Rial',
		numericCode: 886,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.ZAR]: {
		displayName: 'South African Rand',
		numericCode: 710,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'before',
	},
	[Currency.ZMW]: {
		displayName: 'Zambian Kwacha',
		numericCode: 967,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
	[Currency.ZWL]: {
		displayName: 'Zimbabwe Dollar',
		numericCode: 932,
		defaultFractionDigits: 2,
		subUnit: 100,
		spaced: true,
		symbolPosition: 'after',
	},
}

export const CurrencyNarrowSymbol = {
	AED: 'د.إ',
	AFN: '؋',
	ALL: 'L',
	AMD: '֏',
	ANG: 'ƒ',
	AOA: 'Kz',
	ARS: '$',
	AUD: '$',
	AWG: 'ƒ',
	AZN: '₼',
	BAM: 'KM',
	BBD: '$',
	BDT: '৳',
	BGN: 'лв.',
	BHD: '.د.ب',
	BIF: 'Fr',
	BMD: '$',
	BND: '$',
	BOB: 'Bs.',
	// BOV: 'Bs.',
	BRL: 'R$',
	BSD: '$',
	BTN: 'Nu.',
	BWP: 'P',
	BYN: 'Br',
	BZD: '$',
	CAD: '$',
	CDF: 'Fr',
	CHF: 'Fr.',
	CKD: '$',
	CLP: '$',
	CNY: '¥',
	COP: '$',
	CRC: '₡',
	CUC: '$',
	CUP: '$',
	CVE: '$',
	CZK: 'Kč',
	DJF: 'Fr',
	DKK: 'kr.',
	DOP: '$',
	DZD: 'د.ج',
	EGP: '£',
	ERN: 'Nfk',
	ETB: 'Br',
	EUR: '€',
	FJD: '$',
	FKP: '£',
	FOK: 'kr',
	GBP: '£',
	GEL: '₾',
	GGP: '£',
	GHS: '₵',
	GIP: '£',
	GMD: 'D',
	GNF: 'Fr',
	GTQ: 'Q',
	GYD: '$',
	HKD: '$',
	HNL: 'L',
	HRK: 'kn',
	HTG: 'G',
	HUF: 'Ft',
	IDR: 'Rp',
	ILS: '₪',
	IMP: '£',
	INR: '₹',
	IQD: 'ع.د',
	IRR: '﷼',
	ISK: 'kr',
	JEP: '£',
	JMD: '$',
	JOD: 'د.ا',
	JPY: '¥',
	KES: 'Sh',
	KGS: 'с',
	KHR: '៛',
	KID: '$',
	KMF: 'Fr',
	KPW: '₩',
	KRW: '₩',
	KWD: 'د.ك',
	KYD: '$',
	KZT: '₸',
	LAK: '₭',
	LBP: 'ل.ل',
	LKR: 'Rs',
	LRD: '$',
	LSL: 'L',
	// LTL: 'Lt',
	// LVL: 'Ls',
	LYD: 'ل.د',
	MAD: 'د.م.',
	MDL: 'L',
	MGA: 'Ar',
	MKD: 'ден',
	MMK: 'Ks',
	MNT: '₮',
	MOP: 'P',
	MRO: 'UM',
	MUR: '₨',
	MVR: '.ރ',
	MWK: 'MK',
	MXN: '$',
	MYR: 'RM',
	MZN: 'MT',
	NAD: '$',
	NGN: '₦',
	NIO: 'C$',
	NOK: 'kr',
	NPR: 'रू',
	NZD: '$',
	OMR: 'ر.ع.',
	PAB: 'B/.',
	PEN: 'S/.',
	PGK: 'K',
	PHP: '₱',
	PKR: '₨',
	PLN: 'zł',
	PND: '$',
	PRB: 'р.',
	PYG: '₲',
	QAR: 'ر.ق',
	RON: 'lei',
	RSD: 'din.',
	RUB: '₽',
	RWF: 'Fr',
	SAR: '﷼‎',
	SBD: '$',
	SCR: '₨',
	SDG: 'ج.س.',
	SEK: 'kr',
	SGD: '$',
	SHP: '£',
	SLL: 'Le',
	SLS: 'Sl',
	SOS: 'Sh',
	SRD: '$',
	SSP: '£',
	STD: 'Db',
	SYP: '£',
	SZL: 'L',
	SVC: '₡',
	THB: '฿',
	TJS: 'ЅМ',
	TMT: 'm',
	TND: 'د.ت',
	TOP: 'T$',
	TRY: '₺',
	TTD: '$',
	TVD: '$',
	TWD: '$',
	TZS: 'Sh',
	UAH: '₴',
	UGX: 'Sh',
	USD: '$',
	UYU: '$',
	UZS: "so'm",
	VEF: 'Bs.',
	VND: '₫',
	VUV: 'Vt',
	WST: 'T',
	XAF: 'Fr',
	XCD: '$',
	XOF: 'Fr',
	XPF: '₣',
	YER: 'ر.ي',
	ZAR: 'R',
	ZMW: 'ZK',
	ZWL: '$',
}
